import React from "react";
import TranslationRepositoryContext from "../contexts/TranslationRepositoryContext";

export default function useTranslationRepository() {
    const TranslationRepository = React.useContext(TranslationRepositoryContext);

    if(!TranslationRepository) {
        throw new Error('In hook trying to use TranslationRepository context - but it was not provided.');
    }

    return TranslationRepository;
}